import React from 'react';
import Style from '../shared/Style.js';
import Util from './Util.js';
import { ValueText, SuffixText } from "./ColumnText.js";
import Formatters from '../../attribute/formatter/Formatters.js';
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';
import AttributeColumnRenderer from "./AttributeColumnRenderer.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY = {};
const USAGE = 'table';
export default class UnitAttributeColumnRenderer extends AttributeColumnRenderer {
  renderCell = data => {
    const {
      cell: valueOpts
    } = this.column;
    const {
      value
    } = data;
    const original = data?.row?.original || data?.original;
    const vs = Util.getStyle(valueOpts, original /* , cxt */);
    const vv = Util.getVariant(valueOpts, original, {
      value,
      columnModel: this.column,
      usage: USAGE
    } /* , cxt */);
    const empty = this.column?.cell?.emptyValue;
    const fval = this.formatAndI18nResolveValue(value);
    if (fval == null) {
      return /*#__PURE__*/_jsx(ValueText, {
        variant: vv,
        style: vs,
        children: empty
      });
    }
    if (fval.length === 1) {
      return /*#__PURE__*/_jsx(ValueText, {
        variant: vv,
        style: vs,
        children: fval[0]
      });
    }
    const unitStyle = Util.getStyle(this.column.unit || EMPTY);
    const alignItems = Style.toFlexAlign(this.column?.unit?.align || 'baseline');
    if (vv) {
      return /*#__PURE__*/_jsx(ValueText, {
        variant: vv,
        style: vs,
        children: `${fval[0]} ${fval[1]}`
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        alignItems,
        flexWrap: 'nowrap'
      },
      children: [/*#__PURE__*/_jsx(ValueText, {
        style: vs,
        children: fval[0]
      }), /*#__PURE__*/_jsx(SuffixText, {
        style: unitStyle,
        children: fval[1]
      })]
    });
  };
  formatAndI18nResolveValue = value => {
    const formattedValue = Formatters.format(value, this.column.formatter);
    if (formattedValue == null || formattedValue.length === 0 || typeof formattedValue[0] !== 'string') {
      return null;
    }
    return formattedValue.map(value => I18nResolvers.resolve(value, this.column));
  };
}